/**
 * Daily Ritual page
 * Protected route for daily practice
 */

'use client';

import dynamic from 'next/dynamic';

// Lazy load RitualView to avoid build-time initialization errors
const RitualView = dynamic(
  () => import('@/components/app/RitualView').then((mod) => ({ default: mod.RitualView })),
  {
    ssr: false,
    loading: () => <div className="min-h-screen flex items-center justify-center">Loading...</div>,
  }
);

export default function RitualPage() {
  return <RitualView />;
}
